
import { defineComponent, ref, PropType, getCurrentInstance } from '@vue/composition-api';

export default defineComponent({
  name: 'CreateComment',
  props: {
    parentId: {
      type: Number as PropType<null | number>,
      required: false,
      default: null,
    },
    checkbox: {
      type: Number,
      required: false,
      default: 2,
    },
    isReply: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emit: ['selectFiles', 'onChangeComment', 'onChangePrivate', 'onSubmitComment'],
  setup(props, { emit }) {
    const instance = getCurrentInstance();
    const vm = instance?.proxy;
    const t = vm?.$t ? vm.$t.bind(vm) : (msg: string) => msg;

    const onChangeComment = (e: any) => {
      emit('onChangeComment', e.target.value);
    };

    const onChangePrivate = (e: any) => {
      const PUBLIC = 0;
      const PRIVATE = 1;

      const isPublic = e.target.checked ? PRIVATE : PUBLIC;
      emit('onChangePrivate', isPublic);
    };

    const onSubmitComment = () => {
      emit('onSubmitComment', 0, props.parentId);
    };

    const files = ref([]);
    const images = ref([]);

    const handleFileUpload = (event: any) => {
      const selectedFiles = Array.from(event.target.files);

      selectedFiles.forEach(file => {
        if (file.type.startsWith('image/')) {
          const reader = new FileReader();
          reader.onload = (e: ProgressEvent<FileReader>) => {
            const url = e.target?.result as string;
            images.value.push({ file, url });
          };
          reader.readAsDataURL(file);
        } else {
          files.value.push(file);
        }
      });

      // console.log(selectedFiles);

      event.target.value = ''; // 초기화
      emit('selectFiles', selectedFiles);
    };

    const removeFile = (index: number) => {
      emit('selectFiles', files.value[index]);
      files.value.splice(index, 1);
    };

    const removeImage = (index: number) => {
      emit('selectFiles', images.value[index]);
      // URL.revokeObjectURL(images.value[index].url); // Not needed for data URLs
      images.value.splice(index, 1);
    };

    const formatSize = size => {
      const mb = size / (1024 * 1024);
      return `${mb.toFixed(2)}MB`;
    };

    const fileInputRef = ref<HTMLInputElement | null>(null);
    const imageInputRef = ref<HTMLInputElement | null>(null);

    const triggerFileInput = (type: number) => {
      const IMAGE = 0;
      const FILE = 1;

      if (imageInputRef.value && type === IMAGE) {
        imageInputRef.value.click();
      }

      if (fileInputRef.value && type === FILE) {
        fileInputRef.value.click();
      }
    };

    const autoResize = event => {
      const textarea = event.target;
      textarea.style.height = 'auto'; // 높이를 자동으로 초기화
      textarea.style.height = textarea.scrollHeight + 'px'; // 스크롤 높이에 맞게 높이 설정
    };

    return {
      files,
      images,
      fileInputRef,
      imageInputRef,
      t,
      onChangeComment,
      onChangePrivate,
      onSubmitComment,
      handleFileUpload,
      removeFile,
      removeImage,
      formatSize,
      triggerFileInput,
      autoResize,
    };
  },
});
